<template>
  <div class="component-padding">
      <div class="row">
        <div
          class="col-6 col-md-3"
          v-for="(data,index) in bodyCare.slice(
          (this.currentPage - 1) * this.perPage,
          this.currentPage * this.perPage)"
          :key="index"
        >
          <div @click="goTodetail(data.productId)" class="product-item">
            <div class="product-item-lg">
              <img
                :src="require('@/assets/images/' + data.image)"
                :alt="data.image"
                class="product-item-lg-img"
              />
            </div>
            <h3 class="product-item-title">{{data.productTitle}}</h3>
            <p class="product-item-price">{{data.price}}</p>
          </div>
        </div>
      </div>
      <b-pagination
        class="products_pagination"
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
      ></b-pagination>
  </div>
</template>

<script>
import productsJson from "@/json/db.json";
export default {
  name: "BodyCare",
  data() {
    return {
      perPage: 12,
      currentPage: 1
    };
  },
  methods: {
    goTodetail(prodId) {
      this.$router.push({ name: "details", params: { Pid: prodId } });
    }
  },
  computed: {
    rows() {
      return this.bodyCare.length;
    },
    products() {
      return productsJson.products.map(item => {
        return item;
      });
    },
    bodyCare() {
      return this.products
        .filter(i => i.category === "bodyCare")
        .sort((a, b) => new Date(b.date) - new Date(a.date));
    }
  }
};
</script>